/*
* ヘッダーに関する処理
*/
const $ = require('jquery')

require('../_require/jquery_dashboard')

module.exports = (function () {
  function menu () {
    $('.js-account').viewManager(function () {
      const that = this
      $(document).click(function () {
        that.$el.find('.js-account-menu').hide()
      })
      this.$el.find('.js-account-menu-open').click(function (e) {
        that.$el.find('.js-account-menu').toggle()
        e.stopPropagation()
      })
      this.$el.click(function (e) {
        e.stopPropagation()
      })
    })
  }

  return {
    menu: menu
  }
})()
